/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from 'axios';

//load configurations on theme
import themeConfig from '@/../themeConfig.js';    /* import themeconfig configuration to retrive url of the api to make the calls */

const actions = {

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    updateSidebarWidth({ commit }, width) {
      commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateI18nLocale({ commit }, locale) {
      commit('UPDATE_I18N_LOCALE', locale);
    },
    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val);
    },
    updateUserRole({ commit }, val) {
      commit('UPDATE_USER_ROLE', val);
    },
    updateWindowWidth({ commit }, width) {
      commit('UPDATE_WINDOW_WIDTH', width);
    },


    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    //  The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    getHoteis( { commit }, hoteis){
      axios.get(themeConfig.apiurl + '/spa/hoteis?token='+window.localStorage.getItem('usertoken'))
      .then(function (response) {
        hoteis= response.data;
        commit('GET_HOTEIS', hoteis);     
      })
      .catch(function(error){
        console.log(error)
      });
    },  

    getTerapeutas( { commit }, terapeutas){
      axios.get(themeConfig.apiurl + '/spa/pessoas?token='+window.localStorage.getItem('usertoken'))
      .then(function (response) {
        terapeutas= response.data;
        commit('GET_TERAPEUTAS', terapeutas);     
      })
      .catch(function(error){
        console.log(error)
      });
    },  

    getSpas( { commit }, spas){
      axios.get(themeConfig.apiurl + '/spa/spas?token='+window.localStorage.getItem('usertoken'))
      .then(function (response) {
        spas= response.data;
        commit('GET_SPAS', spas);     
      })
      .catch(function(error){
        console.log(error)
      });
    },  

    getRooms( { commit }, rooms){
      axios.get(themeConfig.apiurl + '/spa/rooms?token='+window.localStorage.getItem('usertoken'))
      .then(function (response) {
        rooms= response.data;
        commit('GET_ROOMS', rooms);     
      })
      .catch(function(error){
        console.log(error)
      });
    },  

    getTiposEvento( { commit }, spa_id){
      axios.get(themeConfig.apiurl + '/spa/types/event?token='+window.localStorage.getItem('usertoken'))
      .then(function (response) {
        commit('GET_TIPOS_EVENTO', response.data);     
      })
      .catch(function(error){
        console.log(error)
      });
    }, 

    addSpa( {commit,state} , data){
      commit('SET_SPAS', data);      
    }, 

    addTerapeuta( {commit,state} , data){
      commit('SET_TERAPEUTA', data);      
    },  

    addRoom( {commit,state} , data){
      commit('SET_ROOM', data);      
    },  

    addLoginUserDetails( {commit,state} , data){
      commit('SET_LOGIN_USER_DETAILS', data);      
    }, 

    modifySelectedSpa( {commit,state} , data){
      axios.get(themeConfig.apiurl + '/spa/spa/details/byId/' + data + '?token='+window.localStorage.getItem('usertoken'))
      .then(function (response) {
        if(response.status == 200)
        { 
          commit('MODIFY_SELECTED_SPA', response.data[0]);     
        }
      })
      .catch(function(error){
        console.log(error)
      });
    },

    removeSelectedSpa( {commit,state} ){
      commit('REMOVE_SELECTED_SPA');
    },

    editSpa( {commit,state} , data){
      commit('EDIT_SPA', data);     
    },

    storeListTherapists({commit,state} , data){
      commit('SET_LIST_THERAPISTS', data);
    },

    editTherapist( {commit,state} , data){
      commit('EDIT_THERAPIST', data);     
    },

    storeListSpaRooms({commit,state} , data){
      commit('SET_LIST_SPA_ROOMS', data);
    },

    editSpaRooms( {commit,state} , data){
      commit('EDIT_SPA_ROOMS', data);    
    },
    
    storeListEvents({commit,state} , data){
      commit('SET_LIST_EVENTS', data);
    },

    editListEvents( {commit,state} , data){ 
      commit('EDIT_LIST_EVENTS', data);      
    },

    storeListSpaSearchedUsers({commit,state} , data){
      commit('SET_LIST_SPA_SEARCHED_USERS', data);
    },

    editListSpaSearchedUsers( {commit,state} , data){    
      commit('EDIT_LIST_SPA_SEARCHED_USERS', data); 
    },

    storeListTherapistsBySpa({commit,state} , data){
      commit('SET_LIST_THERAPISTS_BY_SPA', data);
    },

    editListTherapistsBySpa( {commit,state} , data){    
      commit('EDIT_LIST_THERAPISTS_BY_SPA', data);
    },
} 

export default actions
